<template>
  <div class="error-notification" :style="rightPosition">
    <div>{{ error }}</div>
  </div>
</template>

<script>
  export default {
    name: "ErrorNotification",
    data() {
      return {
        right: '-100rem'
      };
    },
    props: {
        error: null
    },
    computed: {
      rightPosition() {
        return {
          right: this.right
        };
      }
    },
    mounted() {
      setTimeout(() => {
        this.right = '1rem';
      }, 500);

      setTimeout(() => {
        this.$store.commit("basket/setError", null);
      }, 10000);
    }
  }
</script>

<style scoped lang="scss">
  .error-notification{
    position: fixed;
    bottom: 1rem;
    background-color: #fff;
    padding: 0.5rem 1rem;
    border: 1px solid #fd813d;
    z-index: 100;
    transition: all 1s ease;
  }
</style>